import {CopyIcon} from '@primer/octicons-react'
import type {ButtonProps} from '@primer/react'
import {Button, VisuallyHidden} from '@primer/react'
import {Announce} from '@primer/react/experimental'

import {useCopyToClipboard} from './use-copy-to-clipboard'

export interface CopyToClipboardButtonProps extends Omit<ButtonProps, 'onClick'> {
  /**
   * Optional callback that is invoked after copying is initiated.
   */
  onCopy?: () => void
  /**
   * Text that will be copied to the clipboard.
   */
  textToCopy: string
}

export function CopyToClipboardButton({
  children,
  className,
  leadingVisual = CopyIcon,
  onCopy,
  textToCopy,
  ...forwardProps
}: CopyToClipboardButtonProps) {
  const {announcement, copied, copyToClipboard, visual} = useCopyToClipboard({
    onCopy,
    textToCopy,
    visual: leadingVisual,
  })

  return (
    <>
      {announcement && (
        <VisuallyHidden>
          <Announce>{announcement}</Announce>
        </VisuallyHidden>
      )}
      <Button {...forwardProps} className={className} leadingVisual={visual} onClick={copyToClipboard}>
        {copied ? 'Copied' : children}
      </Button>
    </>
  )
}
